import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { MenuItem } from "@chakra-ui/react";
import { Statement } from "hooks/statements/useStatements";
import { api } from "utils/api";
import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { LoanContext } from "providers/loan";

interface StatementMenuItemDeleteProps {
    statement: Statement;
}

export function StatementMenuItemDelete({
    statement,
}: StatementMenuItemDeleteProps) {
    const { loan } = useContext(LoanContext);

    const queryClient = useQueryClient();

    const handleDelete = async (statementId: string) => {
        await api.delete(`loans/${loan?.id}/statements/${statementId}`);
        queryClient.invalidateQueries({ queryKey: ["statements"] });
    };

    return (
        <MenuItem
            icon={<FontAwesomeIcon icon={["far", "trash-can"]} />}
            color={"red"}
            onClick={() => handleDelete(statement.id)}
        >
            Delete
        </MenuItem>
    );
}
